"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_player_1 = require("react-player");
var styles = require("./VideoPlayer.css");
var VideoPlayer = /** @class */ (function (_super) {
    __extends(VideoPlayer, _super);
    function VideoPlayer(props) {
        return _super.call(this, props) || this;
    }
    VideoPlayer.prototype.render = function () {
        return (React.createElement("div", { className: styles.playerWrapper },
            React.createElement(react_player_1.default, { className: styles.playerWrapper, url: this.props.url, playing: this.props.options.playing, controls: this.props.options.controls })));
    };
    return VideoPlayer;
}(React.Component));
exports.default = VideoPlayer;
//# sourceMappingURL=VideoPlayer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/VideoPlayer/VideoPlayer.js
// module id = 1290
// module chunks = 8